export default __webpack_public_path__ + "static/media/section-bg.1ab0ec1d.png";